// extracted by css-extract-rspack-plugin
export default {"item":"mN6Sx","itemIcon":"HVMfB","itemLabel":"pQ3bZ"};